import React from 'react';
import PropTypes from 'prop-types';

import QueueStepConfig from './queueStepConfig';
import RedirectStepConfig from './redirectStepConfig';

const TYPES_MAPPING = {
    QueueStep: QueueStepConfig,
    RedirectStep: RedirectStepConfig
};

export default function StepTypeConfig({ steps, step, widget, config, onUpdate, onConfigUpdate }) {
    if (!step || !widget) {
        return null;
    }

    let Component = TYPES_MAPPING[step.step_class];
    if (!Component) {
        return null;
    }

    return <Component steps={steps} step={step} widget={widget} config={config} onUpdate={onUpdate} onConfigUpdate={onConfigUpdate} />;
}

StepTypeConfig.propTypes = {
    step: PropTypes.object,
    widget: PropTypes.object,
    config: PropTypes.object
};
